export default "__VITE_ASSET__rnSBk$eo__"